<!-- eslint-disable -->
<template>
  <div class='c25_main_content'>
    <div class="c25_grid_container">
      <div class="c25_logo_container">
        <img
          @click.prevent="gotoHome"
          src="/dynamic/images/placeholder.png"
          class="c25_top_left_logo"
          v-bind:class="{c25_top_left_logo_hidden:activeSubpage === 'home' }"
        >
      </div>
      <div class="c25_header_row">
        <div class="c25_company_name"></div>
        <div v-bind:class="{c25_hide_header:activeSubpage == 'home'}" class="c25_company_tagline"></div>
        <div class="c25_dashboard_btn_container">
          <button v-if="!isInitiailized && DV_disableDashboardButton" :disabled="true" class="c25_loading_btn">Loading...</button>
          <button v-else @click.prevent="gotoDashboard" class="c25_dashboard_btn">
          </button>
        </div>
      </div>
     
      <div class="c25_nav_buttons">
        <div v-bind:class="{ c25_active_tab: activeSubpage === 'home' }" 
          class="c25_tab c25_tab_home" 
          @click.prevent="selectSubpage('home')"
        >
        </div>
        <div v-bind:class="{ c25_active_tab: activeSubpage === 'about' }"
          class="c25_tab c25_tab_about" 
          @click.prevent="selectSubpage('about')"
        >
        </div>
        <div v-bind:class="{ c25_active_tab: activeSubpage === 'downloads' }"
          class="c25_tab c25_tab_download" 
          @click.prevent="selectSubpage('downloads')"
        >
        </div>
      </div>
      <div class="c25_panel">
        <component 
          :is="currentTabComponent"
          :subItemIndex="1"
          :subItemsList="subItemsList"
          v-on:event-sub-items-change="eventSubItemsChange"
          v-on:event-parameter-change="eventParamsChange"
          v-on:event-sub-items-loaded="eventSubItemsLoaded"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {bi10PageTemplate} from '../../watchdog_includes/base_i10_UI_mixins'

export default {
  name: "c25LandingHeader",
  components: {
    Home: () => import(`./${window.G_brand_id}/p1Home`),
    About: () => import(`./${window.G_brand_id}/p5About`),
    Downloads: () => import(`./${window.G_brand_id}/p3Downloads`)
  },
  mixins: [bi10PageTemplate],
  data: function() {
    return {
      baseUrl: "",
      userInfo: {},
      defaultSubpage: 'home',
      overrideAuthCallbacks: true,
      isGuest: false,
      authenticated: false,
      contactEmail: '',
      DV_disableDashboardButton: true
    };
  },
  computed: {
    currentTabComponent() {
      switch(this.activeSubpage) {
        case 'home':
          return 'Home'
          break;
        case 'about':
          return 'About'
          break;
        case 'downloads':
          return 'Downloads'
          break;
      }
    }
  },
  mounted() {
    if (this.isInitiailized === true) {
      this.DV_disableDashboardButton = false;
    } else {
      // 4 seconds delay to wait until Firebase DB connects and userInfo updates.
      setTimeout(() => {
        this.DV_disableDashboardButton = false;
      }, 4000);
    }
  },
  methods: {
    gotoHome: function() {
      this.selectSubpage('home')
    },
    gotoDashboard() {
      if(window.G_firebase_auth.IV_token_verified === true && window.G_firebase_auth.IV_is_guest === false) {
        window.vue_instance.$router.push('/dashboard');
        return;
      }

      if(this.authenticated !== true || this.isGuest === true) {
        localStorage.clear();
        localStorage.removeItem('vuex');
        location.assign(window.location.origin + '/login');
        return;
      }
      
      if(this.authenticated === true && this.isGuest === false) {
        window.vue_instance.$router.push('/dashboard');
      }
    },
    waitWatchdogReadyCallback() {
      this.userInfo = window.vue_instance.$root.$data.userInfo;
      this.isGuest  = window.vue_instance.$root.$data.userInfo.isGuest;
      this.authenticated  = window.vue_instance.$root.$data.userInfo.authenticated;
      this.contactEmail = window.vue_instance.$root.$data.userInfo.contactEmail;
    }

  }
};
</script>


// WEBPACK FOOTER //
// src/components/public/c25LandingHeader.vue